'use strict';
var isObject = require('../internals/is-object');

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};



//////////////////
// WEBPACK FOOTER
// /Users/oliward/Sites/ihg-gfg-2021/site/web/app/themes/gfg-2023/node_modules/core-js/internals/is-possible-prototype.js
// module id = 192
// module chunks = 0